/* WonderBuddy - "one screen per section" fit engine.

   The sticky header permanently covers the top of the viewport, so the space a
   visitor can actually see in one go is (viewport height - header height), not
   the full viewport. Every section on the site was sized against the full
   viewport, which is why each one lands a little past the fold and the page
   never rests on a whole section.

   This file measures that real visible band and makes each section land inside
   it. A section taller than the band is scaled down with `zoom`; a section
   shorter than it can optionally be stretched to fill it.

   Why `zoom` and not `transform: scale()`:
     - zoom keeps the element's width resolving against its parent, so the
       full-bleed backgrounds these sections rely on still span the viewport.
       transform: scale() would shrink the box and leave bars down both sides.
     - zoom does not create a containing block, so anything inside that uses
       position: sticky or fixed (the buy box column, the cart drawer) keeps
       working. transform breaks both.
     - measured on the live theme: zoom .8 on a 1280x963 section rendered
       1280x768 - width untouched, height exactly proportional, no horizontal
       overflow anywhere on the page.

   Settings come from the header section, which writes window.wbFitConfig
   before this file runs. Nothing here reads the DOM for configuration, so a
   page without the header simply gets the defaults. */
(function () {
  if (window.wbFitInit) { return; }
  window.wbFitInit = true;

  var C = window.wbFitConfig || {};

  function num(v, fallback) {
    var n = parseFloat(v);
    return isFinite(n) ? n : fallback;
  }

  var cfg = {
    on: C.on !== false,
    mOn: C.mOn !== false,
    bp: num(C.bp, 900),
    pct: num(C.pct, 100),
    mPct: num(C.mPct, 100),
    minScale: num(C.minScale, 70),
    mMinScale: num(C.mMinScale, 70),
    grow: C.grow === true,
    mGrow: C.mGrow === true,
    stretch: num(C.stretch, 112),
    mStretch: num(C.mStretch, 120),
    rules: typeof C.rules === 'string' ? C.rules : ''
  };

  /* Every page this script runs on, described as one lowercase haystack that
     rules can be matched against: the URL path, plus the template name and the
     product / collection / page / article handle handed over by the header.
     The URL alone would nearly do it, but a custom template suffix (a product
     using product.storybox-mini rather than the default) never appears in the
     URL, and that is exactly the kind of thing a merchant wants to target. */
  var pageKey = ((C.page || '') + ' ' + location.pathname).toLowerCase();

  /* Rules, in the two shapes the exceptions box accepts:

       playlists: 140          - that section, on every page it appears on
       tiger > reviews: off    - that section, only on pages matching "tiger"
       tiger > all: off        - every section, only on pages matching "tiger"

     The page-scoped form exists because section NAMES repeat across pages by
     design. Every StoryBox Mini product page carries a section named
     "reviews"; they hold different videos, so the height that suits one can be
     wrong on the next, and an unscoped `reviews: off` would hit all of them at
     once. Scoping is what makes a rule land on one page only, without any
     section file having to know about it.

     Kept as a list rather than a name-keyed map so two rules may name the same
     section - one broad, one scoped to a page - and both survive to be weighed
     against each other in ruleFor(). */
  var rules = [];
  cfg.rules.split(/[,\n]/).forEach(function (part) {
    var bits = part.split(':');
    if (bits.length < 2) { return; }

    var left = bits[0].trim().toLowerCase();
    var val = bits[1].trim().toLowerCase();

    var page = null;
    var cut = left.indexOf('>');
    if (cut > -1) {
      page = left.slice(0, cut).trim().replace(/^\/+|\/+$/g, '');
      left = left.slice(cut + 1).trim();
      if (!page) { page = null; }
    }

    var name = left.replace(/\s+/g, '_');
    if (!name) { return; }
    /* "all" and "*" both read naturally as every-section; accept either. */
    if (name === 'all' || name === '*') { name = '*'; }

    rules.push({
      page: page,
      name: name,
      value: (val === 'off' || val === 'no' || val === 'none') ? 0 : num(val, 100)
    });
  });

  /* Sections that must never be touched: the header itself (it is what we are
     measuring against), the footer, and Shopify's own zero-height utility
     sections.

     The footer is matched on the <footer> element as well as #footer-group,
     because this theme renders the group as a bare <footer> with no id - so the
     id check alone missed it and the footer was being scaled to 83% along with
     everything else. A footer is never a thing you land on and read; it is what
     you arrive at, and it should be whatever height its content is. */
  function skip(sec) {
    if (sec.querySelector('[data-wb-hd]')) { return true; }
    if (sec.id.indexOf('cart-drawer') > -1) { return true; }
    if (sec.closest('#footer-group, footer')) { return true; }
    return false;
  }

  /* The element that actually carries the section's background. Shopify's
     #shopify-section-* wrapper is a bare div; the paint sits on the section's
     own root inside it, after the stylesheet <link>, the <script> and the
     inline <style> the section renders. Stretching the wrapper instead of this
     is what put white bands above and below a grown section on tall screens -
     the wrapper got taller, the coloured element did not. */
  function paintRoot(sec) {
    for (var i = 0; i < sec.children.length; i++) {
      var c = sec.children[i];
      if (!/^(LINK|SCRIPT|STYLE|TEMPLATE|NOSCRIPT)$/.test(c.tagName)) { return c; }
    }
    return null;
  }

  /* The most specific rule that matches wins, not the first one written, so
     the order lines are typed in never changes the outcome. Naming a page is
     worth more than naming a section, which is what lets a broad default and a
     one-page exception sit in the box together and do the obvious thing:

       reviews: 120            <- the house default for every reviews row
       tiger > reviews: off    <- except on Tiger, where it wins

     Ties fall to whichever was written first, which only happens when two
     lines are equally specific - i.e. the merchant wrote the same rule twice. */
  function ruleFor(sec) {
    var id = sec.id.replace(/^shopify-section-/, '').toLowerCase();
    var best = null;
    var bestScore = -1;

    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.page && pageKey.indexOf(r.page) === -1) { continue; }
      if (r.name !== '*' && id.indexOf(r.name) === -1) { continue; }

      var score = (r.page ? 2 : 0) + (r.name === '*' ? 0 : 1);
      if (score > bestScore) {
        bestScore = score;
        best = r.value;
      }
    }
    return best;
  }

  function headerHeight() {
    var group = document.getElementById('header-group');
    var bar = document.querySelector('[data-wb-hd]');
    var el = group || (bar && bar.parentElement) || bar;
    if (!el) { return 0; }
    var h = el.getBoundingClientRect().height;
    /* A header that is not stuck to the top scrolls away and does not eat any
       of the visible band, so it should not be subtracted. */
    var stuck = getComputedStyle(group || bar).position;
    if (stuck !== 'sticky' && stuck !== 'fixed') {
      var probe = (group || bar).parentElement;
      var isSticky = false;
      while (probe && probe !== document.body) {
        var p = getComputedStyle(probe).position;
        if (p === 'sticky' || p === 'fixed') { isSticky = true; break; }
        probe = probe.parentElement;
      }
      if (!isSticky) { return 0; }
    }
    return h;
  }

  var running = false;

  function fit() {
    if (running) { return; }
    running = true;

    /* Seen for real on the live theme: the first frame after a navigation can
       report innerWidth/innerHeight as 0, which would make the band negative
       and hand every section a nonsense target. Back off and try again rather
       than writing that to the page. */
    if (window.innerHeight < 300 || window.innerWidth < 200) {
      running = false;
      setTimeout(fit, 200);
      return;
    }

    var mobile = window.innerWidth <= cfg.bp;
    var pct = mobile ? cfg.mPct : cfg.pct;
    var floor = (mobile ? cfg.mMinScale : cfg.minScale) / 100;
    var grow = mobile ? cfg.mGrow : cfg.grow;
    var stretch = mobile ? cfg.mStretch : cfg.stretch;
    var enabled = mobile ? cfg.mOn : cfg.on;

    var headH = headerHeight();
    document.documentElement.style.setProperty('--wb-header-h', Math.round(headH) + 'px');

    var band = window.innerHeight - headH;
    document.documentElement.style.setProperty('--wb-screen-band', Math.round(band) + 'px');

    var sections = document.querySelectorAll('[id^="shopify-section"]');
    Array.prototype.forEach.call(sections, function (sec) {
      if (skip(sec)) { return; }

      /* Always clear first: the natural height has to be measured with no zoom
         and no forced min-height, or every resize would compound the last
         pass's scale into the next one. */
      sec.style.zoom = '';
      sec.style.minHeight = '';
      sec.style.display = '';
      sec.style.flexDirection = '';
      sec.style.justifyContent = '';
      var root = paintRoot(sec);
      if (root) {
        root.style.minHeight = '';
        root.style.alignContent = '';
      }

      if (!enabled) { return; }

      var rule = ruleFor(sec);
      if (rule === 0) { return; }
      var target = band * ((rule === null ? pct : rule) / 100);
      if (target < 120) { return; }

      var natural = sec.getBoundingClientRect().height;
      /* Thin ribbons (the trust strip, a divider) are not "sections" in the
         sense the visitor experiences them, and blowing one up to fill a
         screen would look broken. */
      if (natural < 160) { return; }

      /* One division would be enough if zoom were a pure scale, but a section
         holding anything sized in vw/vh (the carousel cards, a hero art panel)
         reflows a little under zoom instead of scaling cleanly, and lands a
         few percent off. Re-measuring and correcting converges in two passes;
         the loop bails as soon as it fits or stops moving. */
      var z = 1;
      var rendered = natural;
      for (var pass = 0; pass < 4; pass++) {
        if (rendered <= target + 1) { break; }
        var nz = Math.max(floor, z * (target / rendered));
        if (Math.abs(nz - z) < 0.004) { break; }
        z = nz;
        sec.style.zoom = z;
        rendered = sec.getBoundingClientRect().height;
      }

      /* Stretching is capped against the section's OWN natural height, not
         against the screen. On a 1000px-tall monitor the band is 916px and the
         homepage hero is naturally 778px: filling the band outright added 138px
         of nothing, read as a void, and looked worse than before any of this
         existed. Capped at 112% it gains 45px instead - enough that the next
         section peeks in as a scroll cue, not enough to look empty. Laptops and
         phones, where the section is taller than the band anyway, never reach
         this branch and are unaffected.

         A section named outright in the exceptions box is the exception: the
         cap is a guard against the AUTOMATIC choice overreaching, and someone
         who typed a number for one named section has already made that call
         themselves. Without this, writing `reviews: 120` on a short reviews row
         silently did nothing - the cap held it at 112% - which is the kind of
         setting-that-appears-broken that costs an afternoon to work out. */
      var ceiling = (rule === null)
        ? Math.min(target, natural * (stretch / 100))
        : target;
      if (grow && rendered < ceiling - 1) {
        /* min-height goes on the painted element, in its own (zoomed)
           coordinate space, so it has to be divided back out to land on
           `ceiling` real pixels. align-content centres the contents without
           changing the element's display, so a section that lays itself out
           with grid or flex keeps doing exactly that. */
        if (root) {
          root.style.minHeight = Math.round(ceiling / z) + 'px';
          root.style.alignContent = 'center';
        }
      }
    });

    running = false;
  }

  /* Resize fires in bursts, so that one is debounced. The load passes are
     deliberately separate timers rather than debounced calls - each is a
     re-measure after a different batch of media has settled, and a shared
     debounce would cancel the earlier one every time. */
  var timer;
  function debounced(delay) {
    clearTimeout(timer);
    timer = setTimeout(fit, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }

  /* Media that loads late (hero art, reel posters, the product images in the
     carousels) changes a section's natural height after the first pass, so
     re-measure once everything has landed. */
  window.addEventListener('load', function () {
    setTimeout(fit, 60);
    setTimeout(fit, 500);
    setTimeout(fit, 1400);
  });
  window.addEventListener('resize', function () { debounced(160); });
  document.addEventListener('shopify:section:load', function () { setTimeout(fit, 60); });

  window.wbFit = fit;
})();
